export default "__VITE_ASSET__nXNdtw6G__"